/**

 * V1 triage questions — ordered for drop-off reduction (scope gates early).

 */



export const V1_TRIAGE_QUESTION_IDS = {

  GOAL: 'goal',

  PRIMARY_RESIDENCE: 'primaryResidence',

  CITIZENSHIP: 'citizenship',

  INCOME_TYPE: 'incomeType',

  PROPERTY_TYPE: 'propertyType',

  CREDIT_BAND: 'creditBand',

  PURCHASE_PRICE: 'purchasePrice',

  DOWN_PAYMENT: 'downPayment',

  CURRENT_LOAN_TYPE: 'currentLoanType',

  REFI_GOAL: 'refiGoal',

};



export const V1_TRIAGE_QUESTIONS = [

  {

    id: V1_TRIAGE_QUESTION_IDS.GOAL,

    question: 'What are you trying to do?',

    subtitle: 'This helps me show the right preparation steps — not a loan approval decision.',

    type: 'radio',

    options: [

      { value: 'purchase', label: 'Buy a home' },

      { value: 'refinance', label: 'Refinance my current mortgage' },

    ],

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.PRIMARY_RESIDENCE,

    question: 'Will you live in this home as your main residence?',

    subtitle: 'Most programs in this version are for homes you occupy yourself.',

    type: 'radio',

    options: [

      { value: 'yes', label: 'Yes — I will live there' },

      { value: 'no', label: 'No — second home or rental' },

    ],

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.CITIZENSHIP,

    question: 'What is your citizenship status?',

    subtitle: 'This version supports U.S. citizens and permanent residents.',

    type: 'radio',

    options: [

      { value: 'us-citizen', label: 'U.S. citizen' },

      { value: 'permanent-resident', label: 'Permanent resident (green card)' },

      { value: 'other', label: 'Other' },

    ],

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.INCOME_TYPE,

    question: 'How do you mainly earn your income?',

    type: 'radio',

    options: [

      { value: 'w2', label: 'Employed — I get a regular paycheck' },

      { value: 'other', label: 'Self-employed or other' },

    ],

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.PROPERTY_TYPE,

    question: 'What type of home is it?',

    type: 'radio',

    options: [

      { value: 'sfr', label: 'Detached single-family house' },

      { value: 'other', label: 'Condo, townhouse, or multi-unit' },

    ],

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.CREDIT_BAND,

    question: 'What is your best estimate of your credit score?',

    subtitle: 'Self-reported for preparation only — not a credit pull. Tap help if you are unsure.',

    type: 'creditScore',

    placeholder: 'e.g. 720',

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.PURCHASE_PRICE,

    question: 'About how much do you expect to pay for the home?',

    subtitle: 'A rough estimate is fine.',

    type: 'currency',

    showIf: (a) => a.goal === 'purchase',

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.DOWN_PAYMENT,

    question: 'How much cash are you planning to put toward the purchase?',

    subtitle: 'Money you pay upfront at closing — not the amount you borrow.',

    type: 'currency',

    showIf: (a) => a.goal === 'purchase',

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.CURRENT_LOAN_TYPE,

    question: 'What type of mortgage do you have now?',

    subtitle: 'Check your statement or lender — “not sure” is okay.',

    type: 'radio',

    showIf: (a) => a.goal === 'refinance',

    options: [

      { value: 'fha', label: 'FHA (often says FHA on statements)' },

      { value: 'va', label: 'VA (veteran loan)' },

      { value: 'conventional', label: 'Conventional (typical bank loan)' },

      { value: 'other', label: 'Other or not sure' },

    ],

  },

  {

    id: V1_TRIAGE_QUESTION_IDS.REFI_GOAL,

    question: 'What do you mainly want from your refinance?',

    type: 'radio',

    showIf: (a) => a.goal === 'refinance' && (a.currentLoanType === 'fha' || a.currentLoanType === 'conventional'),

    options: [

      { value: 'lower-payment', label: 'Lower my payment or interest rate' },

      { value: 'cash-out', label: 'Take cash out of my equity' },

    ],

  },

];



export const getVisibleV1TriageQuestions = (answers) =>

  V1_TRIAGE_QUESTIONS.filter((q) => !q.showIf || q.showIf(answers));

